import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'services';
import { history } from 'store';
import {
  LOADING,
  ASYNC_CREATE_FUND,
  ASYNC_EDIT_FUND,
  ASYNC_DELETE_FUND,
  ASYNC_RESTORE_FUND
} from 'store';

function* createFund({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.post, 'funds', payload);

    yield call(history.push, '/funds');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* editFund({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield payload.append('_method', 'PUT');
    yield call(api.post, `funds/${payload.get('id')}`, payload);

    yield call(history.push, '/funds');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* deleteFund({ payload: { id } }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.delete, `funds/${id}`);

    yield call(history.push, '/refresh');
    yield call(history.push, '/funds');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* restoreFund({ payload: { id } }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.get, `funds/restore/${id}`);

    yield call(history.push, '/refresh');
    yield call(history.push, '/funds/trash');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

export default function* root() {
  yield all([
    takeLatest(ASYNC_CREATE_FUND, createFund),
    takeLatest(ASYNC_EDIT_FUND, editFund),
    takeLatest(ASYNC_DELETE_FUND, deleteFund),
    takeLatest(ASYNC_RESTORE_FUND, restoreFund)
  ]);
}
